import React from 'react'
import { STATICS } from 'statics'
import './style.scss'

export function PasswordHeader({ title, subtitle, alert = false }) {
  function renderSubtitle() {
    if (alert) {
      return (
        <div className='warning'>
          <STATICS.SHIELD_ALERT className='icon' />
          <div className='description'>
            <h3>Atualize sua senha</h3>
            <p>{subtitle}</p>
          </div>
        </div>
      )
    }

    return <h3 className='subtitle'>{subtitle}</h3>
  }

  return (
    <div className='password-header'>
      <h1 className='title'>{title}</h1>
      {renderSubtitle()}
    </div>
  )
}
